import React, { useState } from 'react';
import css from './ListingPage.module.css';
import classNames from 'classnames';
import { useStore } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { checkActiveSubscription, urlWithLang } from '../SubscriptionPlans/SubscriptionHelpers';
import { useIntl } from 'react-intl';

const PeopleDetails = props => {
  const { publicData } = props;
  const [showdetails, setShowDetails] = useState(false);
  const state = useStore()?.getState();
  const { currentUser } = state?.user;
  const history = useHistory();
  const buyerPlanLink = urlWithLang('/buyerPlans');
  const sellerPlanLink = urlWithLang('/sellerPlans');
  const toggleDetails = () => {
    // Redirect to home if user already has subscription
    //   if (!checkActiveSubscription(currentUser, 'buyerPlan') && !checkActiveSubscription(currentUser, "sellerPlan")) {
    //     history.push(currentUser?.attributes?.profile?.publicData?.userType !== "seller" ? buyerPlanLink : sellerPlanLink);
    //   } else {
    setShowDetails(prev => !prev);
    //   }
  };
  const intl = useIntl();
  return (
    <div className={css.accourdingBlock}>
      <div
        className={classNames(css.smallHeading, css.dFlex)}
        onClick={() => {
          toggleDetails();
        }}
      >
        <h2 className={css.detailsHeading}>{intl.formatMessage({ id: 'Listing.People.title' })}</h2>
        <div className={css.icons}>
          {showdetails ? (
            <div
              className={css.icon}
              onClick={() => {
                toggleDetails();
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="9"
                viewBox="0 0 16 9"
                fill="none"
              >
                <path d="M15 8L8 1L1 8" stroke="#A645D6" stroke-linecap="round" />
              </svg>
            </div>
          ) : (
            <div
              className={css.icon}
              onClick={() => {
                toggleDetails();
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="10"
                viewBox="0 0 16 10"
                fill="none"
              >
                <path d="M1 1L8 8L15 1" stroke="#A645D6" stroke-width="2" stroke-linecap="round" />
              </svg>
            </div>
          )}
        </div>
      </div>
      {showdetails && (
        <div className={css.detailsExpended}>
          <div className={css.accordingInfo}>
            <div className={css.detailsIcon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M9.96717 19.9999C4.46172 19.982 -0.0237642 15.4846 9.4743e-05 10.003C0.0239537 4.44984 4.50943 -0.0296756 10.0328 0.000148059C15.5859 0.0299717 20.0297 4.52142 19.9999 10.0865C19.976 15.5621 15.4607 20.0238 9.96717 19.9999ZM7.40233 11.5956C5.46976 9.92547 5.55326 7.13994 7.1876 5.56525C8.76826 4.04424 11.2794 4.05617 12.8481 5.59507C14.4526 7.16976 14.5302 9.92547 12.6036 11.5956C13.4983 11.9714 14.2856 12.4963 14.9537 13.1822C15.6277 13.8741 16.1287 14.6794 16.4807 15.592C19.3616 12.3173 19.3736 7.00871 15.8066 3.69232C12.3471 0.477327 6.80586 0.727845 3.64455 4.24704C0.441485 7.81992 0.990241 12.8243 3.52525 15.58C4.26488 13.719 5.55923 12.3889 7.40233 11.5956ZM10.0089 12.5261C7.55741 12.5201 5.36836 14.1783 4.73013 16.5225C4.68838 16.6656 4.70627 16.7432 4.83153 16.8386C5.89325 17.6319 7.06234 18.1687 8.36265 18.4073C10.8559 18.8666 13.1285 18.3417 15.1744 16.8446C15.3056 16.7491 15.3235 16.6597 15.2817 16.5105C14.6256 14.1724 12.4604 12.5321 10.0089 12.5261ZM9.97313 11.0946C11.3987 11.1244 12.5917 9.96126 12.6215 8.51183C12.6513 7.09222 11.4822 5.88138 10.0507 5.85155C8.61317 5.82173 7.4083 6.98485 7.37847 8.43428C7.34865 9.87178 8.51774 11.0707 9.97313 11.0946Z"
                  fill="#0EC3A8"
                />
              </svg>
            </div>
            <div className={css.accordingPoints}>
              <div className={css.lable}>
                {intl.formatMessage({ id: 'Listing.People.nofOwner' })}:
              </div>
              <div className={css.value}>{publicData?.Owners}</div>
            </div>
          </div>

          <div className={css.accordingInfo}>
            <div className={css.detailsIcon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="18"
                viewBox="0 0 22 18"
                fill="none"
              >
                <g clip-path="url(#clip0_172_963)">
                  <path
                    d="M21.9999 16.2898C21.9192 16.6722 21.7954 17.0334 21.521 17.3361C21.1821 17.7132 20.7624 17.931 20.2566 17.9841C20.1383 17.9947 20.0145 18 19.8908 18C13.9617 18 8.03263 18 2.10893 18.0053C1.41487 18.0053 0.8338 17.7929 0.397997 17.2405C0.123602 16.89 0.00523606 16.4916 0.00523606 16.0561C-0.000144229 14.9248 -0.00552452 13.7935 0.00523606 12.6622C0.0267572 10.9838 1.32879 9.61879 3.02896 9.53381C3.92209 9.48601 4.82059 9.50194 5.70834 9.56037C6.07958 9.58692 6.27327 9.53912 6.49924 9.21513C7.10184 8.3547 7.97344 7.90855 9.03336 7.89793C10.3784 7.882 11.7235 7.86606 13.0686 7.90855C14.1823 7.94042 15.0378 8.48217 15.6296 9.41696C15.7318 9.58161 15.8233 9.65066 16.017 9.58692C16.1353 9.54974 16.2698 9.53381 16.399 9.53381C17.3298 9.53381 18.2659 9.48601 19.186 9.56037C20.5848 9.67722 21.7362 10.8191 21.9461 12.1895C21.9568 12.2426 21.973 12.2957 21.9891 12.3488C21.9999 13.6607 21.9999 14.9779 21.9999 16.2898ZM7.17178 16.7094C9.74356 16.7094 12.2777 16.7094 14.8226 16.7094C14.8279 16.6616 14.8333 16.6297 14.8333 16.5978C14.8333 14.7548 14.8441 12.9118 14.8279 11.0688C14.8172 9.94278 13.9886 9.16733 12.8265 9.16202C11.6105 9.15671 10.3946 9.14609 9.17863 9.16733C8.87195 9.17264 8.54375 9.23107 8.26936 9.35854C7.51074 9.71439 7.1664 10.3464 7.17178 11.1697C7.17178 12.9437 7.17178 14.7176 7.17178 16.4863C7.17178 16.5553 7.17178 16.6244 7.17178 16.7094ZM5.88051 16.7147C5.88051 16.6191 5.88051 16.5341 5.88051 16.4491C5.88051 14.7283 5.88051 13.0021 5.88051 11.2812C5.88051 10.7979 5.88051 10.7926 5.37476 10.7873C4.67533 10.782 3.97051 10.782 3.27107 10.7873C3.0989 10.7873 2.92673 10.8085 2.76532 10.851C1.84529 11.1006 1.29651 11.8124 1.29113 12.7684C1.28574 13.836 1.29113 14.9035 1.29113 15.9658C1.29113 16.4916 1.52786 16.7253 2.06589 16.7253C3.26031 16.7253 4.45473 16.7253 5.64916 16.7253C5.7191 16.7253 5.78905 16.7147 5.88051 16.7147ZM16.1246 16.6988C16.173 16.7094 16.1945 16.72 16.2107 16.72C17.5073 16.72 18.7986 16.7253 20.0952 16.7147C20.4611 16.7147 20.7086 16.4385 20.7086 16.0614C20.714 14.946 20.714 13.8307 20.7086 12.7153C20.7032 11.6849 19.9284 10.8669 18.9546 10.8085C18.3574 10.7713 17.7548 10.782 17.1522 10.782C16.8724 10.782 16.598 10.8032 16.3183 10.8138C16.1676 10.8191 16.1138 10.8723 16.1138 11.0316C16.1192 12.8321 16.1192 14.6327 16.1192 16.4332C16.1246 16.5182 16.1246 16.6032 16.1246 16.6988Z"
                    fill="#0EC3A8"
                  />
                  <path
                    d="M11.0085 1.24924e-05C13.1176 0.00532379 14.8285 1.69963 14.8285 3.77635C14.8231 5.85307 13.0961 7.55799 10.9977 7.54737C8.89405 7.54206 7.17773 5.83713 7.17773 3.76573C7.18311 1.6837 8.90481 -0.00529881 11.0085 1.24924e-05ZM11.0031 1.27472C9.59886 1.27472 8.46362 2.39541 8.469 3.77635C8.469 5.14666 9.59886 6.26735 10.9924 6.27797C12.3805 6.28859 13.5372 5.15729 13.5372 3.78166C13.5426 2.39541 12.4074 1.27472 11.0031 1.27472Z"
                    fill="#0EC3A8"
                  />
                  <path
                    d="M4.30925 3.51076C5.88029 3.51607 7.1608 4.77485 7.17156 6.32575C7.17694 7.87665 5.87491 9.16198 4.30387 9.16198C2.72744 9.15667 1.42541 7.86603 1.44155 6.32044C1.4577 4.7536 2.7382 3.50545 4.30925 3.51076ZM4.33077 4.78547C3.4753 4.75892 2.76511 5.43345 2.73282 6.3045C2.70054 7.13307 3.39998 7.85009 4.27697 7.88727C5.11629 7.91914 5.83725 7.22867 5.88029 6.36293C5.91257 5.53437 5.20238 4.81203 4.33077 4.78547Z"
                    fill="#0EC3A8"
                  />
                  <path
                    d="M20.5635 6.33107C20.5581 7.88728 19.2615 9.1673 17.6904 9.15668C16.1194 9.14606 14.8389 7.87135 14.8389 6.32576C14.8389 4.76955 16.1463 3.48952 17.7173 3.50546C19.2884 3.52139 20.5689 4.78548 20.5635 6.33107ZM17.6689 4.78548C16.7973 4.81204 16.0871 5.53969 16.1248 6.36294C16.1678 7.22868 16.8941 7.91915 17.7281 7.88728C18.6051 7.8501 19.3045 7.13308 19.2668 6.30451C19.2346 5.42815 18.5244 4.75892 17.6689 4.78548Z"
                    fill="#0EC3A8"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_172_963">
                    <rect width="22" height="18" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div className={css.accordingPoints}>
              <div className={css.lable}>
                {intl.formatMessage({ id: 'Listing.People.employeeLabel' })}:
              </div>
              <div className={css.value}>{publicData?.range_people2}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PeopleDetails;
